var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.59338 3.91992H3.4067C2.2667 3.91992 1.33337 4.85325 1.33337 5.99325V13.5666C1.33337 14.5333 2.02671 14.9466 2.87337 14.4732L5.49337 13.0132C5.77337 12.8599 6.22671 12.8599 6.50004 13.0132L9.12004 14.4732C9.9667 14.9466 10.66 14.5333 10.66 13.5666V5.99325C10.6667 4.85325 9.73338 3.91992 8.59338 3.91992Z",
    stroke: "#A3A3A3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 5.99325V13.5666C10.6667 14.5333 9.97338 14.9399 9.12671 14.4732L6.50671 13.0132C6.22671 12.8599 5.77337 12.8599 5.49337 13.0132L2.87337 14.4732C2.02671 14.9399 1.33337 14.5333 1.33337 13.5666V5.99325C1.33337 4.85325 2.2667 3.91992 3.4067 3.91992H8.59338C9.73338 3.91992 10.6667 4.85325 10.6667 5.99325Z",
    stroke: "#A3A3A3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 3.40731V10.9807C14.6666 11.9473 13.9733 12.354 13.1266 11.8873L10.6666 10.514V5.99398C10.6666 4.85398 9.73332 3.92065 8.59332 3.92065H5.33331V3.40731C5.33331 2.26731 6.26664 1.33398 7.40664 1.33398H12.5933C13.7333 1.33398 14.6666 2.26731 14.6666 3.40731Z",
    stroke: "#A3A3A3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderHistory);
export default __webpack_public_path__ + "static/media/order-history.ef4cad0e835616978e8e8a423c65bde5.svg";
export { ForwardRef as ReactComponent };